var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomProductType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5806 24.2183L42.092 7.7068C43.2636 6.53523 45.1631 6.53523 46.3347 7.7068L49.1631 10.5352C50.3347 11.7068 50.3347 13.6063 49.1631 14.7779L32.6516 31.2894L25 32.1395V40.9998H47C48.1046 40.9998 49 41.8952 49 42.9998V49.9998C49 51.1043 48.1046 51.9998 47 51.9998H13C11.8954 51.9998 11 51.1043 11 49.9998V33.9998C11 32.8952 11.8954 31.9998 13 31.9998H24.7159L25.5806 24.2183ZM35 49.9998V42.9998H25V49.9998H35ZM37 49.9998H47V42.9998H37V49.9998ZM23 33.9998V40.9998H13V33.9998H23ZM23 42.9998V49.9998H13V42.9998H23ZM27.4908 25.1364L26.9605 29.9094L31.7335 29.3791L32.8997 28.2129L28.657 23.9703L27.4908 25.1364ZM30.0712 22.556L34.3139 26.7987L44.2134 16.8992L39.9707 12.6566L30.0712 22.556ZM41.3849 11.2423L45.6276 15.485L47.7489 13.3637C48.1394 12.9731 48.1394 12.34 47.7489 11.9494L44.9205 9.12102C44.5299 8.73049 43.8968 8.73049 43.5063 9.12102L41.3849 11.2423Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomProductType);
export default __webpack_public_path__ + "static/media/custom-product-type.743103ce.svg";
export { ForwardRef as ReactComponent };